import './plot-label.css';
import { h } from 'preact';

export default function PlotLabel({ label, coordinates, isHighlighted }) {
	return (
		<g className={'plot-label-container' + (isHighlighted ? ' is-highlighted' : '')}>
			<circle cx={(coordinates.x + (coordinates.width / 2))} cy={(coordinates.y + (coordinates.height / 2))} r="28" />
			<text x={(coordinates.x + (coordinates.width / 2))} y={(coordinates.y + (coordinates.height / 2))}>{label}</text>
		</g>
	);
}
